import React from 'react';
import ViewAllGamesBtn from '../UI/Buttons/ViewAllGamesBtn';
import { connect } from 'react-redux';
import { withContent } from '../../hoc/withContext';
import { IAppState, IState } from '../../types/store/reducer';
import { IContent } from '../../types';
import Games from './Games/Games';
import { adobeTrack, getNavigationPageLink } from '../../utils';

interface IGamesProps {
  app: IAppState;
  context?: IContent;
}

const Gamelist = ({ app, context }: IGamesProps) => {
  return (
    <section className="advantages_ubisoft-plus ubisoft-plus_container game-list-wrapper">
      <div className="game-selection_outer">
        <h2
          className={'gamelist-title'}
          dangerouslySetInnerHTML={{ __html: context.gamelist.title }}
        />
        <p
          className={'gamelist-description'}
          dangerouslySetInnerHTML={{ __html: context.gamelist.description }}
        />
        <div className=" game-selection_inner">
          <Games countryCode={app.countryCode} />
        </div>
      </div>
      <div className="ubisoft-plus_cta_wrapper">
        <ViewAllGamesBtn
          content={context.cta.see_games}
          redirect={getNavigationPageLink('games')}
          handleClick={() =>
            adobeTrack('clickevent', context.tracking.view_all_games)
          }
        />
      </div>
    </section>
  );
};

const mapStateToProps = (state: IState) => ({
  app: state.app
});

export default connect(mapStateToProps)(withContent(Gamelist));
